﻿export class WorkItem {
    workItemId: string;
    public workflowInstanceId: string;
    state: string;
    arrivalDate: string;
    lastModifiedDate: string;
    dueDate: string;
    claimDate: string;
    claimUserId: string;
    title: string;
    priority: number;
    keywords: string;
    attributeValue1: string;
    attributeSortValue1: string;
    attributeValue2: string;
    attributeSortValue2: string;
    attributeValue3: string;
    attributeSortValue3: string;
    attributeValue4: string;
    attributeSortValue4: string;
    attributeValue5: string;
    attributeSortValue5: string;
    attributeValue6: string;
    attributeSortValue6: string;
    attributeValue7: string;
    attributeSortValue7: string;
    attributeValue8: string;
    attributeSortValue8: string;
    attributeValue9: string;
    attributeSortValue9: string;
    attributeValue10: string;
    attributeSortValue10: string;
    stepName: string;
    stepTitle: string;
    definitionName: string;
    definitionVersion: string;
    definitionTitle: string;
    data: string;
    readOnly: boolean;
    versionId: string;
    freshlyCreated: boolean;
    autoClaimed: boolean;
}